import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'

export const formatCityState = (city?: string, state?: string): string => {
  if (state) state = capitalize(state, state.length === 2) // uppercase if abbrev

  if (city && state) {
    return `${capitalize(city)}, ${state}`
  }
  if (state) {
    return state
  }
  return DISPLAY.empty
}
